const axios = require("axios").default;

const URL_BASE = `${process.env.REACT_APP_API_URL}`;
const URL = `${process.env.REACT_APP_API_URL}/return`;
const URL_PARAM = `${process.env.REACT_APP_API_URL}/param`;
const URL_EXCEL = `${process.env.REACT_APP_API_URL}/return/xlsx`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};

export const getId = (id) => {
  return axios.get(`${URL}/${id}`, {
    params: id,
  });
};

export const getParam = (payload) => {
  return axios.get(URL_PARAM, {
    params: payload,
  });
};

export const getExcel = (payload) => {
  return axios.get(URL_EXCEL, {
    params: payload,
  });
};

export const postApproval = (retNumber, payload) => {
  return axios.post(`${URL}/${retNumber}/sendSO`, payload).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const postInvoiceSap = (retNumber) => {
  return axios.post(`${URL}/${retNumber}/getInvoice`);
};

export const deleteById = (id) => {
  console.log(id, "id");
  return axios.delete(`${URL}/${id}`).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const rejectById = (payload, id) => {
  console.log(id, "id");
  return axios.post(`${URL}/reject/${id}`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
